<template>
  <div v-if="initialized">
    <v-row>
      <v-col>
        <p>{{ $t('becomeACreator.usernameDescriptionPart1') }}</p>
        <p>{{ $t('becomeACreator.usernameDescriptionPart2') }}</p>
      </v-col>
    </v-row>
    <v-row>
      <v-container style="max-width: 400px">
        <v-row align="center" justify="center" >
          <v-col>
            <p>{{ $t('becomeACreator.currentUsername') }}</p>
            <p style="font-weight: bold;">{{ user.userProfile.username }}</p>
          </v-col>
        </v-row>
        <v-row align="center" justify="center" >
          <v-col>
            <UsernameTextField
              v-model="username"
              :placeholder="$t('admin.users.username')"
              @valid="valid = $event"
              :currentUsername="user.userProfile.username"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-row>
    <v-row>
      <v-col>
        <ApolloMutation :mutation="UPDATE_USER_PROFILE"
          @done="proceed"
          >
          <template v-slot:default="{ mutate, loading }">
            <v-btn 
              :disabled="!canProceed || loading" 
              color="primary" 
              class="px-15"
              :loading="loading"
              @click="username != user.userProfile.username ? mutate({ variables: { username: username, id: user.userProfile.id }}) : proceed()">
              {{ username != user.userProfile.username ? $t('forms.saveAndContinue') : $t('forms.continue') }}
            </v-btn>
          </template>
        </ApolloMutation>
      </v-col>
    </v-row>
  </div>
  <div v-else>
    <v-row>
      <v-col>
        <v-skeleton-loader class="my-3" type="card"></v-skeleton-loader>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import UsernameTextField from "@/components/Reusable/UsernameTextField";
import { UPDATE_USER_PROFILE } from "@/graphql/UserQueries";
import hasLoggedInUser from "@/mixins/hasLoggedInUser";
export default {
  mixins: [hasLoggedInUser],
  components: {
    UsernameTextField,
  },
  data() {
    return {
      username: '',
      valid: false,
      initialized: false,
    };
  },
  watch: {
    user: {
      handler: function (newUser) {
        this.username = newUser.userProfile.username;
        this.initialized = true
      },
      deep: true,
    },
  },
  methods: {
    proceed() {
      this.$router.push({ name: "become-creator-eula" });
    },
  },
  computed: {
    UPDATE_USER_PROFILE() {
      return UPDATE_USER_PROFILE;
    },
    canProceed() {
      if (this.valid || this.username == "" || this.username == this.user.userProfile.username) {
        return true;
      }
      return false;
    }
  }
};
</script>
